import { axios } from '@/utils/request'

// 获取商品列表
export function getOptionList(params) {
  return axios({
    url: `/choosemodel`,
    method: 'get',
    params
  })
}

// 商品提交
export function chooseOption(params) {
  return axios({
    url: `/temporary/save`,
    method: 'post',
    data:params
  })
}

// 获取购物车列表
export function getCartList(params) {
  return axios({
    url: `/temporaries`,
    method: 'get',
    params
  })
}

// 确认提交订单
export function sureCart(params) {
  return axios({
    url: `/purchase/save`,
    method: 'post',
    data:params
  })
}

// 删除订单
export function deleteCart(temporal_id) {
  return axios({
    url: `/temporary/${temporal_id}`,
    method: 'delete',
  })
}
//导出收藏夹订单
export function exportCart(params) {
  return axios({
    url: '/stock/export',
    method: 'get',
    params: params
  })
}
//导出订单表
export function exportList(params) {
  return axios({
    url: '/purchases/export',
    method: 'get',
    params: params
  })
}
//导出所有订单表
export function exportAllList(params) {
  return axios({
    url: '/purchase/export',
    method: 'get',
    params: params
  })
}

// 获取订单列表
export function getSorderList(params) {
  return axios({
    url: `/purchase`,
    method: 'get',
    params
  })
}

//转在途
export function updateList(params) {
  return axios({
    url: `/purchase`,
    method: 'post',
    data:params
  })
}

// 提交物流单
export function updateLogistics(purchase_id,params) {
  return axios({
    url: `/purchase/${purchase_id}`,
    method: 'put',
    data:params
  })
}

// 获取订单详情
export function getBuydetail(params) {
  return axios({
    url: `/purchase/${params.id}/detail`,
    method: 'get',
    params
  })
}

// 获取财务列表
export function getPayorderList(params) {
  return axios({
    url: `/purchase`,
    method: 'get',
    params
  })
}

// 提交付款信息
export function updatePaying(purchase_id,params) {
  return axios({
    url: `/purchase/${purchase_id}`,
    method: 'put',
    data:params
  })
}

// 获取异常订单列表
export function getAbnormalList(params) {
  return axios({
    url: `/purchase/abnormal`,
    method: 'get',
    params
  })
}

//下单
export function exchange(params) {
  return axios({
    url: `/exchange`,
    method: 'post',
    data:params
  })
}
//退款列表
export function getRefundOrderByUid(uid,params){
  return axios({
    url: `/refund/orders/user/${uid}`,
    method: 'GET',
    data: params
  })
}
//退款
export function postApplyRefund(orderNo){
  return axios({
    url: `/refund/order/${orderNo}`,
    method: 'POST'
  })
}

//订单备注
export function remarkPurchase(params) {
  return axios({
    url: `/purchase/abnormal/remark/save`,
    method: 'post',
    data:params
  })
}

// 获取异常订单详情
export function getAbnormaltail(params) {
  return axios({
    url: `/purchase/abnormal/${params.id}/detail`,
    method: 'get',
    params
  })
}

// 处理异常订单详情
export function updateAbnormaltail(purchase_id, params) {
  return axios({
    url: `/return/${purchase_id}`,
    method: 'put',
    data:params
  })
}

export function handleAbnormaltail(params){
  return axios({
    url: `/purchase/abnormal/goods/save`,
    method: 'post',
    data:params
  })
}

// 删除异常订单详情
export function deleteAbnormaltail(purchase_id, params) {
  return axios({
    url: `/return/${purchase_id}`,
    method: 'delete',
    params
  })
}

// 获取订单总价信息
export function getTotal(params) {
  return axios({
    url: `/temporaries/summary`,
    method: 'get',
    params
  })
}
// 兑换货采购平台-订单总表-订单发货
export function sendOut(params,body){
  return axios({
    url: `/purchase/${params.id}/send`,
    method: 'post',
    data:body
  })
}


// 
export function delPurchase(params){
  return axios({
    url: `/purchase/${params.id}`,
    method: 'delete',
    params
  })
}

//订单到店
export function purchaseArrival(id){
  return axios({
    url: `/purchase/${id}/arrival`,
    method: 'post',
  })
}

//完结异常
export function overPurchaseAbnormal(id){
  return axios({
    url: `/purchase/${id}/abnormal/over`,
    method: 'post',
  })
}

//修改订单钉钉单号
export function setPurchaseDingTalkOrderNo(body){
  return axios({
    url: `/purchase/ding_talk_order_no/save`,
    method: 'post',
    data:body
  })
}

//获取订单调拨记录
export function getPurchaseMoveRecord(id,params){
  return axios({
    url: `/purchase/${id}/move/record`,
    method: 'get',
    params
  })
}

//新增调拨
export function addPurchaseMoveRecord(body){
  return axios({
    url:`/purchase/transit/goods/move`,
    method: 'post',
    data:body
  })
}

//一键生成订单
export function createAllPurchaseOrder(){
  return axios({
    url:`/purchase/all/save`,
    method: 'post',
  })
}

//获取必中卡信息
export function getOptionalCard(no){
  return axios({
    url: `/optional_card`,
    method: 'GET',
    params:{
      no
    }
  })
}
//核销必中卡
export function UseOptionalCardStatus(id){
  return axios({
    url: `/optional_card/` + id,
    method: 'POST',
  })
}

//获取欢乐券信息
export function getHappyCoupon(id){
  return axios({
    url: `/happy_coupon/${id}`,
    method: 'GET',
  })
}

//核销欢乐券
export function UseHappyCoupon(id){
  return axios({
    url: `/happy_coupon/${id}/verification`,
    method: 'POST',
  })
}